module.exports = __webpack_public_path__ + "static/img/blog-11.327ee2cd.jpg";